import React, { useMemo } from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function OFakultetu() {
  const { t } = useTranslation();

  const navItems = useMemo(
    () => [
      { id: "story", label: t("aboutFpepPage.nav.story") },
      { id: "timeline", label: t("aboutFpepPage.nav.timeline") },
      { id: "programs", label: t("aboutFpepPage.nav.programs") },
      { id: "international", label: t("aboutFpepPage.nav.international") },
      { id: "projects", label: t("aboutFpepPage.nav.projects") },
      { id: "quality", label: t("aboutFpepPage.nav.quality") },
    ],
    [t],
  );

  const stats = useMemo(
    () => [
      {
        icon: "far fa-building",
        label: t("aboutFpepPage.stats.establishedLabel"),
        value: t("aboutFpepPage.stats.establishedValue"),
      },
      {
        icon: "far fa-calendar-check",
        label: t("aboutFpepPage.stats.teachingLabel"),
        value: t("aboutFpepPage.stats.teachingValue"),
      },
      {
        icon: "fas fa-globe-europe",
        label: t("aboutFpepPage.stats.erasmusLabel"),
        value: t("aboutFpepPage.stats.erasmusValue"),
      },
      {
        icon: "fas fa-award",
        label: t("aboutFpepPage.stats.isoLabel"),
        value: t("aboutFpepPage.stats.isoValue"),
      },
    ],
    [t],
  );

  const timeline = useMemo(
    () => [
      {
        year: "2008",
        title: t("aboutFpepPage.timeline.y2008.title"),
        text: t("aboutFpepPage.timeline.y2008.text"),
      },
      {
        year: "2012",
        title: t("aboutFpepPage.timeline.y2012.title"),
        text: t("aboutFpepPage.timeline.y2012.text"),
      },
      {
        year: "2014",
        title: t("aboutFpepPage.timeline.y2014.title"),
        text: t("aboutFpepPage.timeline.y2014.text"),
      },
      {
        year: "2016",
        title: t("aboutFpepPage.timeline.y2016.title"),
        text: t("aboutFpepPage.timeline.y2016.text"),
      },
      {
        year: "2017",
        title: t("aboutFpepPage.timeline.y2017.title"),
        text: t("aboutFpepPage.timeline.y2017.text"),
      },
      {
        year: "2024",
        title: t("aboutFpepPage.timeline.y2024.title"),
        text: t("aboutFpepPage.timeline.y2024.text"),
      },
    ],
    [t],
  );

  const scrollToId = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const StatCard = ({ icon, label, value }) => (
    <div className="aboutFpepPage__stat">
      <div className="aboutFpepPage__statIcon" aria-hidden="true">
        <i className={icon} />
      </div>
      <div className="aboutFpepPage__statBody">
        <div className="aboutFpepPage__statLabel">{label}</div>
        <div className="aboutFpepPage__statValue">{value}</div>
      </div>
    </div>
  );

  const SectionCard = ({ eyebrow, title, children, cta }) => (
    <section className="aboutFpepPage__card">
      <div className="aboutFpepPage__cardHead">
        <div className="aboutFpepPage__eyebrow">{eyebrow}</div>
        <h2 className="aboutFpepPage__h2">{title}</h2>
      </div>
      <div className="aboutFpepPage__cardBody">{children}</div>
      {cta ? <div className="aboutFpepPage__cardFoot">{cta}</div> : null}
    </section>
  );

  return (
    <>
      <Navbar />
      <Bredcom title={t("breadcrumb.home")} subtitle={t("pages.o-fpep")} />

      <div className="container mt-4 pt-40 aboutFpepPage">
        <div className="row">
          {/* MAIN */}
          <div className="col-lg-8">
            {/* HERO */}
            <header className="aboutFpepPage__hero">
              <div className="aboutFpepPage__heroInner">
                <div className="aboutFpepPage__heroText">
                  <div className="aboutFpepPage__heroEyebrow">
                    <i className="fas fa-university" aria-hidden="true" />
                    <span>{t("aboutFpepPage.hero.eyebrow")}</span>
                  </div>
                  <h1 className="aboutFpepPage__h1">
                    {t("aboutFpepPage.hero.title")}
                  </h1>
                  <p className="aboutFpepPage__lead">
                    {t("aboutFpepPage.hero.lead")}
                  </p>

                  <div className="aboutFpepPage__heroActions">
                    <Link
                      className="aboutFpepPage__btn aboutFpepPage__btn--primary"
                      to="/akreditacija-fpep"
                    >
                      {t("aboutFpepPage.hero.ctaPrimary")}{" "}
                      <i className="fas fa-arrow-right" aria-hidden="true" />
                    </Link>
                    <Link
                      className="aboutFpepPage__btn aboutFpepPage__btn--ghost"
                      to="/svi-studijski-programi"
                    >
                      {t("aboutFpepPage.hero.ctaSecondary")}
                    </Link>
                  </div>
                </div>

                <div
                  className="aboutFpepPage__heroPanel"
                  aria-label="Highlights"
                >
                  <div className="aboutFpepPage__stats">
                    {stats.map((s) => (
                      <StatCard
                        key={s.label}
                        icon={s.icon}
                        label={s.label}
                        value={s.value}
                      />
                    ))}
                  </div>

                  <div
                    className="aboutFpepPage__pillRow"
                    role="navigation"
                    aria-label="On page navigation"
                  >
                    {navItems.map((n) => (
                      <a
                        key={n.id}
                        href={`#${n.id}`}
                        onClick={scrollToId(n.id)}
                        className="aboutFpepPage__pill"
                      >
                        {n.label}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </header>

            {/* STORY */}
            <div id="story" className="aboutFpepPage__anchor" />
            <SectionCard
              eyebrow={t("aboutFpepPage.story.eyebrow")}
              title={t("aboutFpepPage.story.title")}
              cta={
                <div className="aboutFpepPage__inlineCtas">
                  <Link className="aboutFpepPage__linkCta" to="/o-univerzitetu">
                    {t("aboutFpepPage.story.ctaUniversity")}{" "}
                    <i className="fas fa-arrow-right" aria-hidden="true" />
                  </Link>
                  <Link
                    className="aboutFpepPage__linkCta"
                    to="/obezbjedjivanje-kvaliteta"
                  >
                    {t("aboutFpepPage.story.ctaQuality")}{" "}
                    <i className="fas fa-arrow-right" aria-hidden="true" />
                  </Link>
                </div>
              }
            >
              <p className="aboutFpepPage__p">
                {t("aboutFpepPage.story.lead")}
              </p>

              {/* ovo je postojeći tekst sa sajta (ne izmišljamo) */}
              <p className="aboutFpepPage__p">{t("fakultet.p1")}</p>

              {/* dodatak iz tvog dostavljenog teksta */}
              <p className="aboutFpepPage__p">{t("aboutFpepPage.story.p2")}</p>
              <p className="aboutFpepPage__p">{t("aboutFpepPage.story.p3")}</p>

              <div className="aboutFpepPage__note">
                <div className="aboutFpepPage__noteIcon" aria-hidden="true">
                  <i className="fas fa-info-circle" />
                </div>
                <div className="aboutFpepPage__noteText">
                  {t("aboutFpepPage.story.note")}
                </div>
              </div>
            </SectionCard>

            {/* TIMELINE */}
            <div id="timeline" className="aboutFpepPage__anchor" />
            <SectionCard
              eyebrow={t("aboutFpepPage.timeline.eyebrow")}
              title={t("aboutFpepPage.timeline.title")}
            >
              <ol className="aboutFpepPage__timeline" aria-label="Timeline">
                {timeline.map((item) => (
                  <li key={item.year} className="aboutFpepPage__timelineItem">
                    <div className="aboutFpepPage__timelineYear">
                      {item.year}
                    </div>
                    <div className="aboutFpepPage__timelineBody">
                      <div className="aboutFpepPage__timelineTitle">
                        {item.title}
                      </div>
                      <div className="aboutFpepPage__timelineText">
                        {item.text}
                      </div>
                    </div>
                  </li>
                ))}
              </ol>
            </SectionCard>

            {/* PROGRAMS */}
            <div id="programs" className="aboutFpepPage__anchor" />
            <SectionCard
              eyebrow={t("aboutFpepPage.programs.eyebrow")}
              title={t("aboutFpepPage.programs.title")}
              cta={
                <Link
                  className="aboutFpepPage__linkCta"
                  to="/svi-studijski-programi"
                >
                  {t("aboutFpepPage.programs.cta")}{" "}
                  <i className="fas fa-arrow-right" aria-hidden="true" />
                </Link>
              }
            >
              <p className="aboutFpepPage__p">
                {t("aboutFpepPage.programs.lead")}
              </p>

              <div className="aboutFpepPage__grid3">
                <div className="aboutFpepPage__miniCard">
                  <div className="aboutFpepPage__miniCardTitle">
                    {t("programs.osnovne")}
                  </div>
                  <ul className="aboutFpepPage__list">
                    <li>
                      <Link to="/racunovodstvo-finansije-i-bankarstvo">
                        {t("osnovne.rfb")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/menadzment">{t("osnovne.menadzment")}</Link>
                    </li>
                    <li>
                      <Link to="/pravo-osnovne">{t("osnovne.pravo")}</Link>
                    </li>
                  </ul>
                </div>

                <div className="aboutFpepPage__miniCard">
                  <div className="aboutFpepPage__miniCardTitle">
                    {t("programs.specijalisticke")}
                  </div>
                  <ul className="aboutFpepPage__list">
                    <li>
                      <Link to="/menadzment-javnog-sektora-specijalisticke">
                        {t("specijalisticke.mjs")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/menadzment-profitnog-sektora-specijalisticke">
                        {t("specijalisticke.mps")}
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="aboutFpepPage__miniCard">
                  <div className="aboutFpepPage__miniCardTitle">
                    {t("programs.master")}
                  </div>
                  <ul className="aboutFpepPage__list">
                    <li>
                      <Link to="/poslovna-ekonomija">
                        {t("master.poslovnaEkonomija")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/ekonomija-javnog-sektora">
                        {t("master.ekonomijaJavnogSektora")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/pravo-master">{t("master.pravo")}</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </SectionCard>

            {/* INTERNATIONAL */}
            <div id="international" className="aboutFpepPage__anchor" />
            <SectionCard
              eyebrow={t("aboutFpepPage.international.eyebrow")}
              title={t("aboutFpepPage.international.title")}
              cta={
                <Link className="aboutFpepPage__linkCta" to="/erasmus">
                  {t("aboutFpepPage.international.cta")}{" "}
                  <i className="fas fa-arrow-right" aria-hidden="true" />
                </Link>
              }
            >
              <p className="aboutFpepPage__p">
                {t("aboutFpepPage.international.lead")}
              </p>

              <div className="aboutFpepPage__split">
                <div className="aboutFpepPage__splitLeft">
                  <div className="aboutFpepPage__badge">
                    <i className="fas fa-star" aria-hidden="true" />
                    <span>{t("aboutFpepPage.international.badge")}</span>
                  </div>
                  <p className="aboutFpepPage__p">{t("fakultet.p3")}</p>
                  <p className="aboutFpepPage__p">{t("erasmus.mebar01")}</p>
                </div>

                <div className="aboutFpepPage__splitRight">
                  <div className="aboutFpepPage__miniCard aboutFpepPage__miniCard--soft">
                    <div className="aboutFpepPage__miniCardTitle">
                      {t("aboutFpepPage.international.projectsLinkTitle")}
                    </div>
                    <p className="aboutFpepPage__muted">
                      {t("aboutFpepPage.international.projectsLinkText")}
                    </p>
                    <Link to="/projekti" className="aboutFpepPage__linkCta">
                      {t("aboutFpepPage.international.projectsLinkCta")}{" "}
                      <i className="fas fa-arrow-right" aria-hidden="true" />
                    </Link>
                  </div>
                </div>
              </div>
            </SectionCard>

            {/* PROJECTS */}
            <div id="projects" className="aboutFpepPage__anchor" />
            <SectionCard
              eyebrow={t("aboutFpepPage.projects.eyebrow")}
              title={t("aboutFpepPage.projects.title")}
              cta={
                <Link className="aboutFpepPage__linkCta" to="/projekti">
                  {t("aboutFpepPage.projects.cta")}{" "}
                  <i className="fas fa-arrow-right" aria-hidden="true" />
                </Link>
              }
            >
              <p className="aboutFpepPage__p">{t("projekti.p1")}</p>
              <p className="aboutFpepPage__p">{t("projekti.p2")}</p>
            </SectionCard>

            {/* QUALITY */}
            <div id="quality" className="aboutFpepPage__anchor" />
            <SectionCard
              eyebrow={t("aboutFpepPage.quality.eyebrow")}
              title={t("aboutFpepPage.quality.title")}
              cta={
                <div className="aboutFpepPage__inlineCtas">
                  <Link
                    className="aboutFpepPage__linkCta"
                    to="/akreditacija-fpep"
                  >
                    {t("aboutFpepPage.quality.ctaAcc")}{" "}
                    <i className="fas fa-arrow-right" aria-hidden="true" />
                  </Link>
                  <Link
                    className="aboutFpepPage__linkCta"
                    to="/obezbjedjivanje-kvaliteta"
                  >
                    {t("aboutFpepPage.quality.ctaQuality")}{" "}
                    <i className="fas fa-arrow-right" aria-hidden="true" />
                  </Link>
                </div>
              }
            >
              <p className="aboutFpepPage__p">
                {t("aboutFpepPage.quality.lead")}
              </p>

              <ul className="aboutFpepPage__bullets">
                <li>{t("aboutFpepPage.quality.b1")}</li>
                <li>{t("aboutFpepPage.quality.b2")}</li>
                <li>{t("aboutFpepPage.quality.b3")}</li>
              </ul>

              <div className="aboutFpepPage__chipRow" aria-label="Standards">
                <span className="aboutFpepPage__chip">{t("kvalitet.l33")}</span>
                <span className="aboutFpepPage__chip">{t("kvalitet.l34")}</span>
              </div>
            </SectionCard>

            {/* FINAL CTA */}
            <section
              className="aboutFpepPage__finalCta"
              aria-label="Call to action"
            >
              <div className="aboutFpepPage__finalCtaInner">
                <div className="aboutFpepPage__finalCtaText">
                  <h3 className="aboutFpepPage__h3">
                    {t("aboutFpepPage.cta.title")}
                  </h3>
                  <p className="aboutFpepPage__muted">
                    {t("aboutFpepPage.cta.text")}
                  </p>
                </div>

                <div className="aboutFpepPage__finalCtaActions">
                  <Link
                    to="/upis"
                    className="aboutFpepPage__btn aboutFpepPage__btn--primary"
                  >
                    {t("aboutFpepPage.cta.primary")}
                  </Link>
                  <Link
                    to="/kontakt"
                    className="aboutFpepPage__btn aboutFpepPage__btn--ghost"
                  >
                    {t("aboutFpepPage.cta.secondary")}
                  </Link>
                </div>
              </div>
            </section>
          </div>

          {/* SIDEBAR (isti kao prije) */}
          <div className="col-lg-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">{t("sidebar.follow")}</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Facebook"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Instagram"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="YouTube"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>

              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">{t("sidebar.useful")}</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">{t("about.fpep")}</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">
                      {t("admission.Akreditacija")}
                    </Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">{t("upis.title")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">{t("admission.Skolarina")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">{t("saradnja.erasmus")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">{t("saradnja.projekti")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">{t("studenti.dom")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">{t("navbar.Gallery")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">{t("navbar.News")}</Link>
                  </li>
                </ul>
              </section>

              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">{t("sidebar.study")}</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>{t("programs.osnovne")}</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      {t("osnovne.rfb")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      {t("osnovne.menadzment")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      {t("osnovne.pravo")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>{t("programs.master")}</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      {t("master.poslovnaEkonomija")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      {t("master.ekonomijaJavnogSektora")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      {t("master.pravo")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>{t("programs.specijalisticke")}</strong> <br />
                    </span>
                    <Link to="/menadzment-javnog-sektora-specijalisticke">
                      {t("specijalisticke.mjs")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment-profitnog-sektora-specijalisticke">
                      {t("specijalisticke.mps")}
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default OFakultetu;
